/**
 * PATH: packages/email-hub/src/feature/email-layout/formatters.ts
 * FILE_ID: EMAIL-LAYOUT-FORMATTERS-001
 * PURPOSE: Pure display formatting shared by EmailLayout leaves.
 */

export function formatRelativeTime(timestamp: number | null): string | null {
  if (!timestamp) return null
  const seconds = Math.floor((Date.now() - timestamp) / 1000)
  if (seconds < 30) return 'just now'
  if (seconds < 60) return `${seconds}s ago`
  if (seconds < 3600) return `${Math.floor(seconds / 60)}m ago`
  if (seconds < 86400) return `${Math.floor(seconds / 3600)}h ago`
  return `${Math.floor(seconds / 86400)}d ago`
}

/**
 * Compact thousands-separator. Avoids depending on user locale for the
 * "1,234 emails" label so we can read it back to ourselves in support.
 */
export function formatCompact(n: number | null | undefined): string {
  if (n == null) return '—'
  if (n < 1000) return String(n)
  return n.toLocaleString('en-US')
}

/**
 * Human window labels for the backfill walker.
 */
export function windowLabel(days: number): string {
  if (days <= 0) return 'starting…'
  if (days < 60) return `${days} days`
  if (days < 365) return `${Math.round(days / 30)} months`
  if (days < 730) return '1 year'
  return `${Math.round(days / 365)} years`
}
